module.exports = __webpack_public_path__ + "img/avatar.dda3c35d.png";